var map = {
	"./4swap.png": 8727,
	"./B.Watch.png": 6301,
	"./BigONE.png": 839,
	"./MixPay.png": 3471,
	"./Mixin Messenger.png": 110,
	"./OptionDance.png": 9552,
	"./Quill.png": 3103,
	"./TIGA.png": 4973,
	"./Trident.png": 6541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9958;